import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Cta } from '@/components/sections/cta'
import { Team } from '@/components/sections/team'
import { PageHero } from '@/components/sections/page-hero'
import { AboutSplit } from '@/components/sections/about-split'
import { aboutProfessional, aboutPersonal } from '@/constants/content'

const About: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='About us'
                description='Driven by results, powered by personality. Meet the certified team behind Funnel and the standards we hold every campaign to.'
            />

            <PageHero
                segments={[
                    { text: 'Driven by results, powered by' },
                    { text: 'personality.', serif: true }
                ]}
                subtitle='Our team is all about results, but we never forget to bring our unique energy and personality to everything we do. We’re here to deliver impactful solutions while keeping things fun, creative, and true to who we are.'
            />

            <AboutSplit
                id='professional'
                segments={[
                    { text: 'On a' },
                    { text: 'professional', serif: true },
                    { text: 'note' }
                ]}
                items={aboutProfessional}
                image='/images/about-professional.png'
                alt='Three colleagues talking on orange sofas in a sunlit meeting room'
            />

            <AboutSplit
                id='personal'
                imageRight
                segments={[
                    { text: 'On a' },
                    { text: 'personal', serif: true },
                    { text: 'note' }
                ]}
                items={aboutPersonal}
                image='/images/about-personal.png'
                alt='A team meeting around a long wooden table in a bright studio'
            />

            <Team />

            <Cta />
        </Layout>
    )
}

export default About
